/* ============================================================
   Copper Elixir — custom buy box behaviour
   Volume tiers = product variants; subscription = Skio selling plans.
   Drives the theme <product-form>:
     - input[name="id"]           -> selected tier's variant id
     - input[name="selling_plan"] -> Skio plan id (when Subscribe active)
   Prices update live from data-* attributes rendered by the snippet.
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = fmt.match(placeholder);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function initBuyBox(form) {
    if (form.dataset.ceWired === '1') return;
    form.dataset.ceWired = '1';

    var container = form.closest('.ce-buybox-form') || form;
    var moneyFormat = container.getAttribute('data-money-format') || '${{amount}}';
    var atcLabel = container.getAttribute('data-atc-label') || 'Add to cart';
    var oneTimeMeta = container.getAttribute('data-onetime-meta') || 'One-time purchase';
    var saveLabel = container.getAttribute('data-save-label') || 'SAVE';
    var saveDisplay = container.getAttribute('data-save-display') || 'percent';

    var variantInput = form.querySelector('.product-variant-id');
    var qtyInput = form.querySelector('.ce-quantity-input');
    var planInput = form.querySelector('.ce-selling-plan-input');
    var ptypeTabs = Array.prototype.slice.call(form.querySelectorAll('[data-ptype]'));
    var benefits = form.querySelector('[data-sub-benefits]');
    var saleHeading = form.querySelector('[data-sale-heading]');
    var saleFor = saleHeading ? (saleHeading.getAttribute('data-sale-for') || 'both') : 'both';
    var tiers = Array.prototype.slice.call(form.querySelectorAll('[data-tier]'));
    var ctaNow = form.querySelector('[data-cta-now]');
    var ctaCompare = form.querySelector('[data-cta-compare]');
    var hasSub = ptypeTabs.length > 0;

    if (!tiers.length) return;

    var selectedTab = form.querySelector('[data-ptype][aria-selected="true"]');
    var state = {
      ptype: hasSub ? (selectedTab ? selectedTab.getAttribute('data-ptype') : 'subscribe') : 'onetime',
      tier: tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0]
    };

    // A tier can subscribe only if it carries a Skio plan id (i.e. that variant
    // is enrolled in Skio). Otherwise it always adds as a one-time purchase.
    function tierCanSub(t) { return !!t.getAttribute('data-plan'); }

    function renderTier(t, isSub) {
      var canSub = isSub && tierCanSub(t);
      var perCents = num(t.getAttribute(canSub ? 'data-sub-per' : 'data-once-per'));
      var comparePer = num(t.getAttribute('data-compare-per'));

      var now = t.querySelector('[data-now]');
      var compare = t.querySelector('[data-compare]');
      var save = t.querySelector('[data-save]');
      var meta = t.querySelector('[data-meta]');

      if (now) now.textContent = formatMoney(perCents, moneyFormat);
      if (compare) {
        if (comparePer > perCents) {
          compare.textContent = formatMoney(comparePer, moneyFormat);
          compare.style.display = '';
        } else {
          compare.style.display = 'none';
        }
      }
      if (save) {
        var text = '';
        // Amount format is for one-time only (that's where the flat-$ promo lives);
        // the subscription view always falls back to a percentage.
        if (saveDisplay === 'amount' && !canSub) {
          var onceTotal = num(t.getAttribute('data-once-total'));
          var compareTotal = num(t.getAttribute('data-compare-total'));
          if (compareTotal > onceTotal) {
            text = formatMoney(compareTotal - onceTotal, moneyFormat);
          }
        } else {
          var pct = comparePer > 0 ? Math.round((comparePer - perCents) / comparePer * 100) : 0;
          if (pct > 0) text = pct + '%';
        }
        if (text) {
          save.textContent = saveLabel + ' ' + text;
          save.style.display = '';
        } else {
          save.style.display = 'none';
        }
      }
      if (meta) meta.textContent = canSub ? (t.getAttribute('data-plan-name') || '') : oneTimeMeta;
    }

    function updateCta(isSub) {
      if (!state.tier) return;
      var canSub = isSub && tierCanSub(state.tier);
      var total = num(state.tier.getAttribute(canSub ? 'data-sub-total' : 'data-once-total'));
      var compareTotal = num(state.tier.getAttribute('data-compare-total'));
      if (ctaNow) ctaNow.textContent = formatMoney(total, moneyFormat);
      if (ctaCompare) {
        if (compareTotal > total) {
          ctaCompare.textContent = formatMoney(compareTotal, moneyFormat);
          ctaCompare.style.display = '';
        } else {
          ctaCompare.style.display = 'none';
        }
      }
    }

    function render() {
      var isSub = state.ptype === 'subscribe';

      ptypeTabs.forEach(function (t) {
        t.setAttribute('aria-selected', String(t.getAttribute('data-ptype') === state.ptype));
      });
      if (benefits) benefits.style.display = isSub ? '' : 'none';

      // Sale heading can be limited to one purchase type.
      if (saleHeading) {
        var showSale = saleFor === 'both' || (saleFor === 'subscribe' ? isSub : !isSub);
        saleHeading.style.display = showSale ? '' : 'none';
      }

      // Under Subscribe & Save, only show tiers that actually have a plan.
      var visibleTiers = tiers.filter(function (t) { return !isSub || tierCanSub(t); });
      if (visibleTiers.indexOf(state.tier) === -1) {
        state.tier = visibleTiers[0] || tiers[0];
      }

      tiers.forEach(function (t) {
        t.style.display = (!isSub || tierCanSub(t)) ? '' : 'none';
        renderTier(t, isSub);
        var active = t === state.tier;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-checked', String(active));
      });

      var canSub = isSub && state.tier && tierCanSub(state.tier);
      if (variantInput && state.tier) {
        variantInput.value = canSub
          ? state.tier.getAttribute('data-sub-variant-id')
          : state.tier.getAttribute('data-once-variant-id');
        variantInput.removeAttribute('disabled');
      }
      if (qtyInput && state.tier) {
        qtyInput.value = canSub ? '1' : (state.tier.getAttribute('data-once-qty') || '1');
      }
      if (planInput) {
        var plan = state.tier.getAttribute('data-plan');
        if (canSub && plan) {
          planInput.value = plan;
          planInput.removeAttribute('disabled');
        } else {
          planInput.value = '';
          planInput.setAttribute('disabled', 'disabled');
        }
      }

      updateCta(isSub);
    }

    ptypeTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        state.ptype = t.getAttribute('data-ptype');
        render();
      });
    });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-unavailable') === 'true') return;
        state.tier = t;
        render();
      });
    });

    render();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll('form.ce-buybox')).forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
